import ReportedIssuesReview from "./ReportedIssuesReview";
export default ReportedIssuesReview;